import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import useConstructionStore from '../../stores/ConstructionStore'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import CsvUpload from './CSVupload'
import { useParams } from 'react-router-dom'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import CircularProgress from '@material-ui/core/CircularProgress'
import useFormClasses from '../common/FormFields//FormFieldsStyle'

function BlacklistedForm({ building, closeModal }) {
  const classes = useStyles()
  const formClasses = useFormClasses()
  const create = useConstructionStore((state) => state.createConstructionItems)
  const cleanStore = useConstructionStore((state) => state.cleanStoreErrors)
  const loading = useConstructionStore((state) => state.isLoading)
  const [data, setData] = useState([])
  let { id } = useParams()

  const errorItems = useConstructionStore((state) => state.errorItems)

  const countCreated = useConstructionStore((state) => state.countCreated)

  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()

  const handleDownload = () => {
    const fileUrl = '/spotter-import.csv'
    const link = document.createElement('a')
    link.href = fileUrl
    link.download = 'template.csv'
    link.click()
  }

  useEffect(() => {
    const fetchBuildingData = async () => {
      getBuildings()
    }
    fetchBuildingData()
  }, [])

  const onSubmit = async () => {
    await create(id, data)
    // closeModal()
  }

  console.log('data fomr', data, 'errorItems', errorItems)
  if (loading) {
    return (
      <div className={classes.paper}>
        <h2 id="simple-modal-title">Cargar personas</h2>
        <CircularProgress />
      </div>
    )
  }

  return (
    <div className={classes.paper}>
      <h2 id="simple-modal-title" className={classes.formTitle}>
        Cargar personas
      </h2>
      <div style={{ display: 'flex' }}>
        <CsvUpload handleChange={(data) => setData(data)}></CsvUpload>
        <Button
          variant="outlined"
          className={formClasses.secondaryButton}
          style={{ marginLeft: '15px' }}
          onClick={handleDownload}
        >
          Descargar template
        </Button>
      </div>
      {errorItems?.length === 0 && (
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>CI</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Lote</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.ci}</TableCell>
                  <TableCell>{row.nombre}</TableCell>
                  <TableCell>{row.lote}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
      {countCreated > 0 && (
        <p>Personas agregadas correctamente: {countCreated}</p>
      )}
      {errorItems?.length > 0 && (
        <div>
          <p style={{ color: 'red', font: '18px' }}>
            Datos con error {errorItems?.length}
          </p>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>CI</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Lote</TableCell>
                <TableCell>Error</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {errorItems.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ color: 'red', font: '18px' }}>
                    {row.ci}
                  </TableCell>
                  <TableCell style={{ color: 'red', font: '18px' }}>
                    {row.nombre}
                  </TableCell>
                  <TableCell style={{ color: 'red', font: '18px' }}>
                    {row.lote}
                  </TableCell>
                  <TableCell style={{ color: 'red', font: '18px' }}>
                    {row.error}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}

      <div className={classes.buttonsContainer}>
        <Button
          onClick={() => {
            closeModal()
            cleanStore()
          }}
          variant="outlined"
          className={formClasses.secondaryButton}
        >
          Cancelar
        </Button>
        <Button
          className={clsx(classes.buttonsMargin, formClasses.primaryButton)}
          type="submit"
          variant="contained"
          color="primary"
          onClick={onSubmit}
        >
          Guardar
        </Button>
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
    width: '100%',
    '& .Mui-error': {
      color: 'white',
    },
    '& .MuiFormHelperText-root': {
      color: '#f44336',
    },
  },
  paper: {
    position: 'absolute',
    width: 600,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
  },
  formTitle: {
    fontSize: '24px',
  },
  withMargin: {
    marginBottom: '16px',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '16px',
  },
  buttonsMargin: {
    marginLeft: '16px',
  },
  switch: {
    marginTop: '16px',
    marginLeft: '-11px',
  },
  customTimePicker: {
    '& .MuiInputBase-root': {
      color: 'white !important', // Customize the text color
    },
    '& .MuiInput-underline:before': {
      borderColor: 'white', // Customize the underline color
      color: 'white !important', // Customize the text color
    },
    '& .MuiInput-underline:hover:before': {
      borderColor: 'white !important', // Customize the underline color on hover
      color: 'white !important', // Customize the text color
    },

    '& .MuiFormControl-root': {
      borderColor: 'white !important', // Customize the underline color on hover
      color: 'white !important', // Customize the text color
    },
    '& .MuiInputBase-input': {
      borderColor: 'white !important', // Customize the underline color on hover
      color: 'white !important', // Customize the text color
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.23)',
    },
    '& .MuiSvgIcon-root': {
      color: 'white !important', // Customize the
      borderColor: 'white !important',
    },
    '& .MuiFormLabel-root': {
      color: 'white !important', // Customize the
      borderColor: 'white !important',
    },
    '& .Mui-focused': {
      borderColor: 'white !important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        // borderColor: 'white',
        borderColor: 'rgba(255, 255, 255, 0.23)',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
  },
}))

export default BlacklistedForm
